import React, { useState } from "react";
import "./Header.css";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { Nav, Navbar } from "react-bootstrap";

function Header() {
  const location = useLocation();
  const navigate = useNavigate();
  const [expanded, setExpanded] = useState(false);

  const handleNavClick = (path) => {
    navigate(path);
    setExpanded(false);
  };

  return (
    <>
      <section className="header_section">
        <Navbar
          expand="lg"
          className="navbar_sec"
          expanded={expanded}
          onToggle={(value) => setExpanded(value)}
        >
          <div className="navbar_holder container-fluid">
            <Navbar.Brand>
              <div className="logo_wrapper" onClick={() => navigate("/")}>
                <img
                  src="/assets/images/header/infinity-logo.png"
                  alt="Infinity Taxi"
                  className="top_logo"
                />
              </div>
            </Navbar.Brand>
            <Navbar.Toggle aria-controls="basic-navbar-nav" />
            <Navbar.Collapse
              id="basic-navbar-nav"
              className="justify-content-center"
            >
              <Nav>
                <Nav.Link
                  as={Link}
                  to={"/"}
                  onClick={() => setExpanded(false)}
                  className={location.pathname === "/" ? "active" : ""}
                >
                  Home
                </Nav.Link>

                <Nav.Link
                  as={Link}
                  to={"/about-us"}
                  onClick={() => setExpanded(false)}
                  className={location.pathname === "/about-us" ? "active" : ""}
                >
                  About Us
                </Nav.Link>

                <Nav.Link
                  as={Link}
                  to={"/tour-packages"}
                  onClick={() => setExpanded(false)}
                  className={
                    location.pathname === "/tour-packages" ? "active" : ""
                  }
                >
                  Tour Packages
                </Nav.Link>

                <Nav.Link
                  as={Link}
                  to={"/contact-us"}
                  onClick={() => setExpanded(false)}
                  className={`d-lg-none ${
                    location.pathname === "/contact-us" ? "active" : ""
                  }`}
                >
                  Contact Us
                </Nav.Link>
              </Nav>
            </Navbar.Collapse>

            {/* Contact Button */}
            <div
              className="contact_btn_wrapper"
              onClick={() => navigate("/contact-us")}
            >
              <button className="contact_btn">Contact Us</button>
            </div>
          </div>
        </Navbar>
      </section>
    </>
  );
}

export default Header;
